import { PLATFORM_FEATURES } from '@/content/site-content';

/**
 * The dark band that sits directly under the hero and names what the platform
 * does. Black on the left warming to brown on the right, matching the design.
 */
export function FeatureStripSection() {
  return (
    <section aria-label="Platform features" className="bg-white">
      <div className="container-page">
        <ul className="bg-ink-gradient grid grid-cols-2 gap-y-8 rounded-[1.5rem] px-6 py-9 sm:grid-cols-3 lg:grid-cols-6 lg:gap-y-0">
          {PLATFORM_FEATURES.map((feature, index) => (
            <li
              key={feature.title}
              className={`px-3 text-center text-white lg:px-4 ${
                index > 0 ? 'lg:border-l lg:border-white/12' : ''
              }`}
            >
              <feature.icon className="mx-auto size-6 text-brand-600" />
              <p className="mt-2.5 text-sm font-bold">{feature.title}</p>
              <p className="mt-0.5 text-xs text-white/60">{feature.caption}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
